// import React, { useState } from 'react';
import AppLoader from 'components/general/AppLoader';
import { Col, Row, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { notifyEditPermissionDenied } from 'utils/editPermissionToast';
import { getPathwayTitle } from 'utils/pathwayTitle';
// import { ArrowRightCircle } from 'react-bootstrap-icons'

export default function Event({ item, onItemTitleChange, onEventTextClick, closeEditorSignal, canEdit = true }) {
  const [editing, setEditing] = useState(false);
  const [inputValue, setInputValue] = useState(item?.item_title || "");
  const [loading, setLoading] = useState(false);
  const { user: authUser } = useSelector(x => x.auth) || {};
  const url = process.env.REACT_APP_URL;

  // Reset editing when item changes
  useEffect(() => {
    setEditing(false);
    setInputValue(item?.item_title || "");
  }, [item]);

  useEffect(() => {
    setEditing(false);
  }, [closeEditorSignal]);

  // Save or remove item_title in backend
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canEdit || !authUser?.token) {
      notifyEditPermissionDenied(authUser);
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${url}/agendaItem/${item.agendaItemId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + (authUser?.token || '')
        },
        body: JSON.stringify({
          item_title: inputValue.trim() ? inputValue : null // Send null if empty
        })
      });
      if (res.status !== 200 && res.status !== 201) {
        throw new Error('(' + res.status + ') Could not save title');
      }
      const data = await res.json();
      // Update inputValue with the latest value from backend
      setInputValue(data.item_title || "");
      if (onItemTitleChange) {
        await onItemTitleChange(data.item_title || "");
      }
      // Also update item.item_title if possible (if item is mutable)
      if (item && typeof item === 'object') {
        item.item_title = data.item_title || "";
      }
      setEditing(false);
    } catch (err) {
      // Optionally show error (toast, alert, etc.)
      alert(err);
    }
    setLoading(false);
  };

  const handleCancel = () => {
    setInputValue(item?.item_title || "");
    setEditing(false);
  };

  const handleEditClick = () => {
    if (!canEdit) {
      notifyEditPermissionDenied(authUser);
      return;
    }
    if (!authUser?.token) {
      notifyEditPermissionDenied(authUser);
      return;
    }

    if (onEventTextClick) {
      onEventTextClick();
    }
    setEditing(true);
    setInputValue(item?.item_title || "");
  };

  const { speech: speechTitleLine, pathway: pathwayNameLine, project: projectDetailsLine } = getPathwayTitle(item);

  return (
    <>
      <Row>
        <Col>
          {/* <h4 className='text-inline'>{item?.startTime}</h4> */}
          <h1 className='text-inline role-title-centered'>
            <span
              className={item?.activity?.type === 'debate' ? 'activity-debate-event-name' : undefined}
              style={{ cursor: canEdit ? 'pointer' : 'default' }}
              onClick={() => !editing && handleEditClick()}
              title={!canEdit ? '' : (item?.item_title ? 'Edit title' : 'Add title')}
            >
              {item?.activity?.type === 'debate' ? 'DEBATE' : item?.agendaEvent?.name}
            </span>
            <br />
            {/* Inline edit/add for item_title */}
            {editing ? (
              <Form onSubmit={handleSubmit} style={{}}>
                <Row>
                  <Col style={{ position: 'relative' }}>
                    <Form.Control
                      size="sm"
                      type="text"
                      value={inputValue}
                      onChange={e => setInputValue(e.target.value)}
                      autoFocus
                      style={{ padding: inputValue ? '0 28px 0 10px' : '0 10px' }}
                      placeholder="Enter title"
                    />
                    {inputValue && (
                      <button
                        type="button"
                        aria-label="Clear"
                        onClick={() => setInputValue("")}
                        style={{
                          position: 'absolute',
                          right: 20,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          border: 'none',
                          background: 'transparent',
                          padding: 0,
                          margin: 0,
                          cursor: 'pointer',
                          // fontSize: '1.1em',
                          color: 'var(--foreground)',
                          lineHeight: 1,
                          zIndex: 2
                        }}
                        tabIndex={-1}
                      >
                        ×
                      </button>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      variant="success"
                      size="sm"
                      type="submit"
                      disabled={loading}
                      style={{ padding: '0 14px', alignItems: 'center', marginRight: '10px' }}

                    >
                      {loading ? <AppLoader size="sm" inline /> : 'Save'}
                    </Button>
                    <Button
                      variant="secondary"
                      size="sm"
                      type="button"
                      onClick={handleCancel}
                      style={{ padding: '0 14px', alignItems: 'center' }}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>

              </Form>
            ) : (
              !item?.hideTitleAndSubtitle && item?.item_title && (
                <span
                  style={{ marginLeft: 8, fontSize: '0.95em', cursor: canEdit ? 'pointer' : 'default', display: 'inline-block', whiteSpace: 'pre-line' }}
                  onClick={() => !editing && handleEditClick()}
                  title={canEdit ? 'Edit title' : ''}
                >
                  {speechTitleLine || item.item_title}
                  {pathwayNameLine && <small className="pathway-event-detail" style={{ opacity: 0.9 }}>{pathwayNameLine}</small>}
                  {projectDetailsLine && <small className="pathway-event-detail" style={{ opacity: 0.9 }}>{projectDetailsLine}</small>}
                </span>
              )
            )}
          </h1>
        </Col>
      </Row>
      {/* <Row>
        <Col xs={1} lg={3}></Col>
        <Col dangerouslySetInnerHTML={{ __html: item?.agendaEvent.description }} style={{ display: showEventDescription ? 'block' : 'none' }}></Col>
        <Col xs={1} lg={3}></Col>
      </Row> */}
    </>
  );
}